import { useState } from 'react'
import useSWR, { useSWRConfig } from 'swr'
import api from '@/api'

const fetcher = (url) => api.get(url)

export default function useRetailerApi() {
    const [isLoggingIn, setIsLoggingIn] = useState(false)
    const [token, setToken] = useState(() => localStorage.getItem('token'))
    const { mutate: globalMutate } = useSWRConfig()

    const { data: retailer, isLoading } = useSWR(
        token ? '/me' : null,
        fetcher
    )

    const login = async (publicId, pin) => {
        setIsLoggingIn(true)
        try {
            const data = await api.post('/login', { public_id: publicId, pin })
            localStorage.setItem('token', data.token)
            setToken(data.token)
            return data
        } catch (err) {
            setIsLoggingIn(false)
            throw err
        }
    }

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('cart')
        setToken(null)
        setIsLoggingIn(false)
        globalMutate('/me', null, false)
    }

    const associateWarranty = (payload) => api.post('/warranty/associate', payload)

    const fetchShippingCost = (lines) => api.post('/shipping-cost', { lines })

    const submitEstimate = (lines) => api.post('/estimate', { lines })

    const fetchOrders = (offset = 0, limit = 10) =>
        api.get(`/orders?offset=${offset}&limit=${limit}`)

    return {
        retailer,
        isLoading,
        isLoggingIn,
        isAuthenticated: !!retailer,
        login,
        logout,
        associateWarranty,
        fetchShippingCost,
        submitEstimate,
        fetchOrders,
    }
}
